import Image from 'next/image';
import Link from 'next/link';
import { FunctionComponent } from 'react';
const DEFAULT_USER_AVATAR = process.env.DEFAULT_USER_AVATAR || '';

interface TeamModalProps extends React.HTMLAttributes<HTMLDivElement> {
  team: {
    username: any;
    name: string;
    photoUrl: string;
    bio: string;
  }[];
  optIn: () => void;
  hasUserOptIn: boolean;
  closeModal: () => void;
}

const TeamModal: FunctionComponent<TeamModalProps> = ({
  team,
  optIn,
  hasUserOptIn = false,
  closeModal,
  ...rest
}: TeamModalProps) => {
  const onInterested = () => {
    optIn();
    closeModal();
  };

  return (
    <div className={rest.className}>
      <div className="text-2xl font-medium">{"Who's on the team so far"}</div>
      <div className="mt-7">
        {team?.map(member => (
          <div key={member.name}>
            <div className="flex items-center">
              <Link href={`/${member?.username}`}>
                <a className={`h-8 w-8 rounded-xl relative hover:opacity-80`}>
                  <Image className="rounded-xl" layout="fill" src={member?.photoUrl || DEFAULT_USER_AVATAR} />
                </a>
              </Link>
              <Link href={`/${member?.username}`}>
                <a className="font-medium ml-4 hover:underline">{member?.name}</a>
              </Link>
              <div className="ml-3 bg-[#F1EFFF] text-[#4539B2] py-1 px-3 rounded-lg">Lead 🔑</div>
            </div>
            <div className="text-[14px] ml-12 mt-2">{member?.bio}</div>
          </div>
        ))}
      </div>
      <div className="flex items-center mt-8">
        <div className={`h-8 w-8 rounded-lg bg-[#FFF8E7] flex justify-center items-center`}>⚡</div>
        <div className="ml-4 font-medium text-[#323232]">Actively bringing on more builders</div>
      </div>
      <div className="mt-10">
        <button
          onClick={onInterested}
          className={`w-full px-6 py-2.5 font-medium rounded-lg  ${
            hasUserOptIn
              ? 'bg-[#EEEEEE] text-[#868686] cursor-default'
              : 'bg-[#3C3D3E] text-white cursor-pointer hover:opacity-80'
          }`}
        >
          {hasUserOptIn ? "✋ I'm interested ✔️" : "✋ I'm interested"}
        </button>
      </div>
    </div>
  );
};

export default TeamModal;
